var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CrossWindowBase from './base';
/**
 * This class is extended by the Shop and Order messaging modules,
 * and contains logic for the OpenTicketBase communications
 */
export default class CrossWindowServer extends CrossWindowBase {
    constructor(_base, _config) {
        super(_config);
        if (!_base) {
            throw new Error('No OpenTicket instance provided');
        }
        // Set the base instance
        this._base = _base;
        // Listen for notifications
        this._base._eventBus.on(['notification'], (path, data) => {
            this._sendMessage({
                action: 'notification',
                data,
            });
        });
        // Listen for client-notifications (only meant for clients)
        this._base._eventBus.on(['client-notification'], (path, data) => {
            this._sendMessage({
                action: 'client-notification',
                data,
            });
        });
        // Listen for router changes
        this._base._eventBus.on(['router'], (path, data) => {
            this._sendMessage({
                action: 'router',
                data,
            });
        });
    }
    /**
     * Handled messaging for the OpenTicketBase class
     * @param event - data from the event
     */
    onMessage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const message = event.data;
            if (message.scope !== 'client') {
                return;
            }
            yield this.onClientMessage(event);
        });
    }
    /**
     * This method should be implemented by classes using this one,
     * it will be called when a message arrives
     * @param event - The event that is received
     */
    onClientMessage(event) {
        return __awaiter(this, void 0, void 0, function* () {
            // Implement this method in the super class
        });
    }
}
//# sourceMappingURL=server.js.map